<template>
  <el-aside v-if="user" class="col-2">
    <el-menu :default-openeds="['2']">

      <el-menu-item index="1-1">
        <router-link to="/home"class="nav-link" active-class="active">
          <fa icon="home" fixed-width/>
          {{ $t('home') }}
        </router-link>
      </el-menu-item>

      <el-submenu index="2">
        <template slot="title">
          <fa icon="certificate" fixed-width/>
          {{ $t('administrative_acts') }}
        </template>
        <el-menu-item index="2-1">
          <router-link to="/acts" class="nav-link" active-class="active">
          {{ $t('complete_list') }}
          </router-link>
        </el-menu-item>
        <el-menu-item index="2-2">
          <router-link :to="{ name: 'teachersacts', params: { filter:'acts_types', subfilter:1 } }" class="nav-link" active-class="active">
          {{ $t('teachers_list') }}
          </router-link>
        </el-menu-item>
        <el-menu-item index="2-3">
          <router-link :to="{ name: 'administrativesacts', params: { filter:'acts_types', subfilter:2 } }" class="nav-link" active-class="active">
          {{ $t('administratives_list') }}
          </router-link>
        </el-menu-item>
        <el-menu-item index="2-4">
          <router-link :to="{ name: 'projectsacts', params: { filter:'acts_types', subfilter:3 } }" class="nav-link" active-class="active">
          {{ $t('project_list') }}
          </router-link>
        </el-menu-item>
        <el-menu-item index="2-5">
          <router-link to="/acts/new" class="nav-link" active-class="active">
          {{ $t('new') }}
          </router-link>
        </el-menu-item>
      </el-submenu>

      <el-submenu index="3">
        <template slot="title">
          <fa icon="male" fixed-width/>
          {{ $t('people') }}
        </template>
        <el-menu-item index="3-1">
          <router-link to="/people" class="nav-link" active-class="active">
          {{ $t('list') }}
          </router-link>
        </el-menu-item>
        <el-menu-item index="3-2">
          <router-link to="/people/new" class="nav-link" active-class="active">
          {{ $t('new') }}
          </router-link>
        </el-menu-item>
      </el-submenu>

      <el-submenu v-if="show" index="4">
        <template slot="title">
          <fa icon="male" fixed-width/>
          {{ $t('users') }}
        </template>
        <el-menu-item index="3-1">
          <router-link to="/users" class="nav-link" active-class="active">
          {{ $t('list') }}
          </router-link>
        </el-menu-item>
        <el-menu-item index="3-2">
          <router-link to="/users/new" class="nav-link" active-class="active">
          {{ $t('new') }}
          </router-link>
        </el-menu-item>
      </el-submenu>

      <el-menu-item index="5-1">
        <router-link to="/help" class="nav-link" active-class="active">
          <fa icon="question-circle" fixed-width/>
          {{ $t('help') }}
        </router-link>
      </el-menu-item>

    </el-menu>
  </el-aside>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  middleware: 'auth',

  components: {
    
  },

  data() {
    
    return {
      show: false,
    }

  },

  computed: mapGetters({
    user: 'auth/user'
  }),

  created() {

    if (this.user) {
      if(this.user.roles[0].name === 'administrador') this.show = true;
    }

  }
      
}
</script>

<style lang="scss">

  .el-menu {
    height: 100%;
  }
  .el-submenu__title:hover {
    background-color: #ff5a00;
    color: #000;
    & i {
      color: #000;
    }
  }
  .nav-link {
    padding: 0;
  }
  .el-aside {
    position: fixed;
    top: 0;
    padding-left: 0; 
    height: 100%;
    min-height: 100%;
    & > ul {
      padding-top: 50px;
    }
  }
  
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Sidebar.vue